import { CREATE_LINK, UPDATE_LINK, DESTROY_LINK, LOGOUT } from '../actions/actionTypes.js';
import { get, indexOf, filter } from 'lodash';

const linksInitialState = []
const initialState = {
  links: linksInitialState
}


const linksList = (state = linksInitialState, action) => {
  
  if ( indexOf(['smartpage', 'page', 'biolink'], get(action.payload, 'settings.type')) < 0 )
    return state;

  switch (action.type.replace(/^ADMIN_/, '')) {
    case CREATE_LINK.SUCCESS:
    case UPDATE_LINK.SUCCESS:
      return [
        action.payload,
        ...filter(state, ({id}) => id !== action.payload.id)
      ];
    case DESTROY_LINK.SUCCESS:
      return filter(state, ({id}) => id !== action.payload.id)
    case LOGOUT:
      return linksInitialState;
    default:
      return state;
  }
};

export const admin = (state = initialState, action) => {
  return {
    links: linksList(state.links || [], action)
  }
};


// WEBPACK FOOTER //
// ./src/reducers/admin.js